import getValue from "../get-value/file";

export default function(value) {
  return !getValue(value).length;
}
